import logoPng from 'assets/images/hedgeblue_logo_light.png'

const LogoDark = () => {
  return (
    <span className="logo flex flex-row items-center justify-start space-x-2">
      <img src={logoPng} alt="logo" className="w-36" />
      <span className="text-gray-300 text-3xs font-bold align-middle">BETA</span>
    </span>
  )
}

export default LogoDark
